import React from 'react';
import { Countdown } from './Countdown';
import { PRICE_AFTER_LAUNCH } from '../data/product';
export function Urgency() {
  return <section className="w-full bg-field" data-id="element-398" data-mp="2bw5t8tbai5rq">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-16" data-id="element-399" data-mp="1wzf2t9jlg4e9">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-willow" data-id="element-400" data-mp="1x1hs1rcx9thx">Limited-time offer</p>
        <h2 className="mt-3 font-display text-2xl text-cream sm:text-4xl" data-id="element-401" data-mp="220b7hpbrrukq">The launch price ends in:</h2>
        <div className="mt-6" data-id="element-402" data-mp="1o58u6h4lf2xw">
          <Countdown data-id="element-403" data-mp="1sy1vev0urt58" />
        </div>
        <p className="mt-5 text-sm text-cream/70" data-id="element-404" data-mp="1szd2b3plhh0k">
          After that the price goes up to{' '}
          <span className="font-bold text-cherry-soft" data-id="element-405" data-mp="1eagriyw5lpw9">${PRICE_AFTER_LAUNCH}</span> and stays there.
        </p>
      </div>
    </section>;
}